const idiomas = [
  { code: "af", name: "Afrikaans" },
  { code: "az", name: "Azerbaijani" },
  { code: "id", name: "Indonesian" },
  { code: "ms", name: "Malay" },
  { code: "ca", name: "Catalan" },
  { code: "cs", name: "Czech" },
  { code: "da", name: "Danish" },
  { code: "de", name: "German" },
  { code: "et", name: "Estonian" },
  { code: "en", name: "English" },
  { code: "es", name: "Spanish" },
  { code: "eu", name: "Basque" },
  { code: "fil", name: "Filipino" },
  { code: "fr", name: "French" },
  { code: "gl", name: "Galician" },
  { code: "hr", name: "Croatian" },
  { code: "zu", name: "Zulu" },
  { code: "is", name: "Icelandic" },
  { code: "it", name: "Italian" },
  { code: "sw", name: "Swahili" },
  { code: "lv", name: "Latvian" },
  { code: "lt", name: "Lithuanian" },
  { code: "hu", name: "Hungarian" },
  { code: "nl", name: "Dutch" },
  { code: "no", name: "Norwegian" },
  { code: "uz", name: "Uzbek" },
  { code: "pl", name: "Polish" },
  { code: "pt", name: "Portuguese" },
  { code: "ro", name: "Romanian" },
  { code: "sq", name: "Albanian" },
  { code: "sk", name: "Slovak" },
  { code: "sl", name: "Slovenian" },
  { code: "sr", name: "Serbian" },
  { code: "fi", name: "Finnish" },
  { code: "sv", name: "Swedish" },
  { code: "vi", name: "Vietnamese" },
  { code: "tr", name: "Turkish" },
  { code: "el", name: "Greek" },
  { code: "bg", name: "Bulgarian" },
  { code: "ru", name: "Russian" },
  { code: "uk", name: "Ukrainian" },
  { code: "ka", name: "Georgian" },
  { code: "hy", name: "Armenian" },
  { code: "he", name: "Hebrew" },
  { code: "ur", name: "Urdu" },
  { code: "ar", name: "Arabic" },
  { code: "fa", name: "Persian" },
  { code: "ne", name: "Nepali" },
  { code: "mr", name: "Marathi" },
  { code: "hi", name: "Hindi" },
  { code: "as", name: "Assamese" },
  { code: "bn", name: "Bengali" },
  { code: "pa", name: "Punjabi" },
  { code: "gu", name: "Gujarati" },
  { code: "or", name: "Odia" },
  { code: "ta", name: "Tamil" },
  { code: "te", name: "Telugu" },
  { code: "kn", name: "Kannada" },
  { code: "ml", name: "Malayalam" },
  { code: "si", name: "Sinhala" },
  { code: "th", name: "Thai" },
  { code: "lo", name: "Lao" },
  { code: "my", name: "Burmese" },
  { code: "km", name: "Khmer" },
  { code: "ko", name: "Korean" },
  { code: "zh-Hans", name: "Chinese (Simplified)" },
  { code: "zh-Hant", name: "Chinese (Traditional)" },
  { code: "ja", name: "Japanese" },
];

export default idiomas;
